import { Button } from 'primereact/button';
import Moment from 'react-moment';
import { InputText } from 'primereact/inputtext';
import 'moment/locale/fr';
import React, { useState, useEffect } from "react";
import { send } from "../../../services/NotificationService";

import {
    Outlet,
    useLoaderData
} from "react-router-dom";
import { getPublicRental, hub, savePublicRentalRefundBankAccount } from "../../../data/loca/rentals";
import { getSimilarCategory, getPublicToolAssets } from "../../../data/loca/tools";
import { getSettings } from "../../../data/loca/settings";
import { IsNullOrEmpty } from "../../../services/CustomService";
import { calendarStrings } from '../../../services/calendarStrings';
// import specific css
import '../../../assets/css/rental-public.css';

import {
    HubConnectionBuilder,
    HubConnectionState,
} from '@microsoft/signalr';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { ProgressSpinner } from 'primereact/progressspinner';
export async function loader({ params }) {
    const rental = await getPublicRental(params.rentalId);
    if (rental.status === 404) {
        send("warning", rental.message)
        return { rental };

    } else {
        return { rental };
    }

   
}
export default function PublicRental({ state }) {
    const { rental } = useLoaderData();

    const [loading, setLoading] = useState(false);
    const [loadingAdvance, setLoadingAdvance] = useState(false);
    const [loadingDeposit, setLoadingDeposit] = useState(false);
    const [loadingRefundBankAccount, setLoadingRefundBankAccount] = useState(false);
    const [refundBankAccountSubmitted, setRefundBankAccountSubmitted] = useState(!IsNullOrEmpty(rental.depositRefundIban));
    const [refundBankAccountOwner, setRefundBankAccountOwner] = useState(rental.depositRefundBankAccountOwner || "");
    const [refundIban, setRefundIban] = useState(rental.depositRefundIban || "");
    const [refundBic, setRefundBic] = useState(rental.depositRefundBic || "");
    const [isMobileView, setIsMobileView] = useState(false);
    const [similarStartIndex, setSimilarStartIndex] = useState(0);
    const [similarVisibleCount, setSimilarVisibleCount] = useState(4);
    const [similarTools, setSimilarTools] = useState(null);
    const [assets, setAssets] = useState([]);
    const [toolCustomUrl, setToolCustomUrl] = useState("");
    const [settings, setSettings] = useState(null);
    const [showContractPreview, setShowContractPreview] = useState(false);
    const [loadingContractPreview, setLoadingContractPreview] = useState(false);
    const [loadingSimilarTools, setLoadingSimilarTools] = useState(rental.status !== 404 && !!rental.toolPublicId);
    const boardId = rental.rentalUserPublicId + "/" + rental.rentalPublicId;


    useEffect(() => {
        if (rental.status === 404 || !rental.toolPublicId) {
            return undefined;
        }

        let isMounted = true;
        Promise.all([
            getSimilarCategory(rental.toolPublicId).catch(() => null),
            getPublicToolAssets(rental.toolPublicId).catch(() => null),
            getSettings().catch(() => null)
        ]).then(([loadedSimilarTools, toolAssets, loadedSettings]) => {
            if (!isMounted) {
                return;
            }

            setSimilarTools(loadedSimilarTools);
            setAssets(toolAssets?.assets || []);
            setToolCustomUrl(toolAssets?.toolCustomUrl || "");
            setSettings(loadedSettings);
            setLoadingSimilarTools(false);
        });

        return () => {
            isMounted = false;
        };
    }, [rental.status, rental.toolPublicId]);

    useEffect(() => {
        if (rental.status === 404) {
            return;
        }

        setUpSignalRPublicApiConnection(boardId);
    }, [boardId, rental.status]);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        const updateView = (event) => {
            setIsMobileView(event.matches);
        };

        setIsMobileView(mediaQuery.matches);

        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', updateView);
        } else {
            mediaQuery.addListener(updateView);
        }

        return () => {
            if (mediaQuery.removeEventListener) {
                mediaQuery.removeEventListener('change', updateView);
            } else {
                mediaQuery.removeListener(updateView);
            }
        };
    }, []);

    useEffect(() => {
        const updateSimilarVisibleCount = () => {
            const width = window.innerWidth;
            if (width < 576) {
                setSimilarVisibleCount(1);
            } else if (width < 768) {
                setSimilarVisibleCount(2);
            } else if (width < 1200) {
                setSimilarVisibleCount(3);
            } else {
                setSimilarVisibleCount(4);
            }
        };

        updateSimilarVisibleCount();
        window.addEventListener('resize', updateSimilarVisibleCount);
        return () => window.removeEventListener('resize', updateSimilarVisibleCount);
    }, []);

    const setUpSignalRPublicApiConnection = async (boardId: string) => {
        try {
            const hubLink = await hub();
            if (!hubLink) {
                return null;
            }

            const publicApiconnection = new HubConnectionBuilder()
                .withUrl(hubLink + 'lokappdhub')
                .withAutomaticReconnect()
                .build();

            publicApiconnection.on('RentalUpdated', () => {
                window.location.reload();
            });

            await publicApiconnection.start();
            if (publicApiconnection.state === HubConnectionState.Connected) {
                await publicApiconnection.invoke('SubscribeToRental', boardId);
            }
            return publicApiconnection;
        } catch (err) {
            // Le suivi temps réel est facultatif : la location reste consultable sans SignalR.
            return null;
        }
    };

    const redirectToPayment = () => {
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
            let link = `/public/paiement/${rental.rentalPublicId}`

            window.location.href = link;
        }, 2000);

    }

    const redirectToAdvancePayment = () => {
        setLoadingAdvance(true);

        setTimeout(() => {
            setLoadingAdvance(false);
            let link = `/public/acompte/${rental.rentalPublicId}`

            window.location.href = link;
        }, 2000);

    }

    const redirectToDeposit = () => {
        setLoadingDeposit(true);

        setTimeout(() => {
            setLoadingDeposit(false);
            let link = `/caution/${rental.rentalPublicId}`

            window.location.href = link;
        }, 2000);

    }

    const similarLink = (customUrl) => {

        let link = `https://lokapp.fr/outil/${customUrl}`

            window.location.href = link;
     

    }

    const productTemplate = (product) => {
        return (
            <div className="rental-similar-card">
                <div className="rental-similar-media">
                    {product.base64Picture ? (
                        <img loading="lazy" alt={product.name} src={product.base64Picture} />
                    ) : (
                        <div className="no-picture"></div>
                    )}
                </div>
                <div className="rental-similar-body">
                    <h4 className="nameCarousel">{product.name}</h4>
                    {product.model && <p className="rental-similar-model">{product.model}</p>}
                    <p className="rental-similar-price">{product.priceDayCents / 100}€/j</p>
                    <div className="rental-similar-actions">
                        <Button label="Voir l'outil" icon="pi pi-search" size="small" onClick={() => similarLink(product.customUrl)} />
                    </div>
                </div>
            </div>
        );
    };
    const formatEuroAmount = (amount) => Number(amount ?? 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var labelAdvanced = "Déposer l'acompte de " + formatEuroAmount(rental.advancePaymentAmount) + "€";
    const hasDelivery = rental.delivery === "DeliveryWithPickup"
        || rental.delivery === "DeliveryWithPickupAndSetup"
        || rental.delivery === "DeliveryOnly";
    const hasAssets = assets && assets.length > 0;
    const publicSiteUrl = (settings?.publicSiteUrl || "https://lokapp.fr").replace(/\/+$/, "");
    const materialUrlBase = `${publicSiteUrl}/materiel/${toolCustomUrl}`;
    const assetDisplayLabel = (asset) => {
        if (!IsNullOrEmpty(asset.title)) {
            return asset.title;
        }

        return asset.assetType === 'video' ? 'Vidéo' : 'Notice';
    };
    const needsAdvancePayment = rental.advancePaymentDone === false && rental.remainingToBePaidCents > 0;
    const bankTransferInstruction = rental.advancePaymentBankTransferInstruction || rental.AdvancePaymentBankTransferInstruction;
    const bankTransferInstructionRequired = bankTransferInstruction?.isRequired ?? bankTransferInstruction?.IsRequired;
    const bankTransferInstructionReference = bankTransferInstruction?.transferReference ?? bankTransferInstruction?.TransferReference;
    const bankTransferInstructionBeneficiary = bankTransferInstruction?.beneficiary ?? bankTransferInstruction?.Beneficiary;
    const bankTransferInstructionIban = bankTransferInstruction?.iban ?? bankTransferInstruction?.Iban;
    const bankTransferInstructionBic = bankTransferInstruction?.bic ?? bankTransferInstruction?.Bic;
    const bankTransferInstructionBankName = bankTransferInstruction?.bankName ?? bankTransferInstruction?.BankName;
    const showAdvancePaymentBankTransferInstruction = bankTransferInstructionRequired && needsAdvancePayment;
    const showAdvancePaymentBankTransferReceived = bankTransferInstructionRequired && !needsAdvancePayment && rental.advancePaymentDone !== false;
    const canPayAdvanceOnline = needsAdvancePayment && !showAdvancePaymentBankTransferInstruction && rental.publicAdvancePaymentEnabled !== false;
    const advancePaymentOnSiteRequired = showAdvancePaymentBankTransferInstruction || (needsAdvancePayment && rental.publicAdvancePaymentEnabled === false);
    const signatureBlocksContractAndAddress = rental.signatureRequired && rental.canAccessContractAndAddress === false;
    const depositActionAvailable = !signatureBlocksContractAndAddress;
    const hasCardDeposit = rental.depositType === "CB";
    const hasBankTransferDeposit = rental.depositType === "BankTransfer";
    const needsCardDeposit = hasCardDeposit && rental.depositDone === false;
    const needsBankTransferDeposit = hasBankTransferDeposit && rental.depositDone === false;
    const canDepositOnline = depositActionAvailable && needsCardDeposit && rental.canDepositOnline;
    const showCardDepositPending = depositActionAvailable && needsCardDeposit && !canDepositOnline;
    const depositBankTransferInstruction = rental.depositBankTransferInstruction || rental.DepositBankTransferInstruction;
    const depositBankTransferReference = depositBankTransferInstruction?.transferReference ?? depositBankTransferInstruction?.TransferReference;
    const depositBankTransferBeneficiary = depositBankTransferInstruction?.beneficiary ?? depositBankTransferInstruction?.Beneficiary;
    const depositBankTransferIban = depositBankTransferInstruction?.iban ?? depositBankTransferInstruction?.Iban;
    const depositBankTransferBic = depositBankTransferInstruction?.bic ?? depositBankTransferInstruction?.Bic;
    const depositBankTransferBankName = depositBankTransferInstruction?.bankName ?? depositBankTransferInstruction?.BankName;
    const showDepositBankTransferInstruction = depositActionAvailable && needsBankTransferDeposit;
    const showRefundBankAccountForm = depositActionAvailable && hasBankTransferDeposit;
    const canPayOnline = rental.webPaymentAvalaible;
    const isPaid = rental.remainingToBePaidCents === 0;
    const isPlatformPaymentService = Boolean(rental.servicePaymentFlow) && rental.servicePaymentFlow !== "Direct";
    const paymentOnSiteRequired = rental.publicRentalPaymentEnabled === false && !isPaid && !needsAdvancePayment && !isPlatformPaymentService;
    const showSignatureTodo = signatureBlocksContractAndAddress && rental.advancePaymentDone !== false;
    const canAccessContract = !IsNullOrEmpty(rental.pdf);
    const hasAction = showSignatureTodo || canPayAdvanceOnline || advancePaymentOnSiteRequired || showAdvancePaymentBankTransferReceived || canDepositOnline || showCardDepositPending || showDepositBankTransferInstruction || (hasBankTransferDeposit && rental.depositDone) || canPayOnline || paymentOnSiteRequired || isPaid;
    const similarItems = similarTools?.items || [];
    const normalizedSimilarStartIndex = similarItems.length
        ? similarStartIndex % similarItems.length
        : 0;
    const visibleSimilarItems = similarItems.length <= similarVisibleCount
        ? similarItems
        : Array.from({ length: similarVisibleCount }, (_, index) => similarItems[(normalizedSimilarStartIndex + index) % similarItems.length]);
    const canSlideSimilar = similarItems.length > similarVisibleCount;
    const moveSimilar = (direction) => {
        if (!canSlideSimilar) {
            return;
        }

        setSimilarStartIndex((current) => {
            const next = current + (direction * similarVisibleCount);
            return (next + similarItems.length) % similarItems.length;
        });
    };

    const copyBankTransferValue = async (label, value) => {
        if (!value) {
            return;
        }

        try {
            await navigator.clipboard.writeText(value);
            send("success", `${label} copié`);
        } catch {
            send("warning", "Impossible de copier automatiquement.");
        }
    };

    const bankTransferAmount = `${formatEuroAmount(rental.advancePaymentAmount)}€`;
    const bankTransferFields = [
        { label: "Motif", value: bankTransferInstructionReference },
        { label: "Bénéficiaire", value: bankTransferInstructionBeneficiary },
        { label: "IBAN", value: bankTransferInstructionIban },
        { label: "BIC", value: bankTransferInstructionBic },
        { label: "Banque", value: bankTransferInstructionBankName }
    ].filter((field) => !IsNullOrEmpty(field.value));
    const depositBankTransferFields = [
        { label: "Motif", value: depositBankTransferReference },
        { label: "Bénéficiaire", value: depositBankTransferBeneficiary },
        { label: "IBAN", value: depositBankTransferIban },
        { label: "BIC", value: depositBankTransferBic },
        { label: "Banque", value: depositBankTransferBankName }
    ].filter((field) => !IsNullOrEmpty(field.value));
    const renderCopyableBankTransferField = (field) => (
        <div className="rental-public-bank-field" key={field.label}>
            <span>
                <small>{field.label}</small>
                <b>{field.value}</b>
            </span>
            <Button
                type="button"
                icon="pi pi-copy"
                text
                rounded
                severity="secondary"
                aria-label={`Copier ${field.label}`}
                onClick={() => copyBankTransferValue(field.label, field.value)}
            />
        </div>
    );

    useEffect(() => {
        if (!canSlideSimilar) {
            return undefined;
        }

        const timer = window.setInterval(() => {
            setSimilarStartIndex((current) => {
                const next = current + similarVisibleCount;
                return (next + similarItems.length) % similarItems.length;
            });
        }, 6000);

        return () => window.clearInterval(timer);
    }, [canSlideSimilar, similarItems.length, similarVisibleCount]);

    const saveRefundBankAccount = async (event) => {
        event.preventDefault();

        if (IsNullOrEmpty(refundBankAccountOwner) || IsNullOrEmpty(refundIban)) {
            send("warning", "Le titulaire et l'IBAN sont obligatoires.");
            return;
        }

        setLoadingRefundBankAccount(true);
        try {
            await savePublicRentalRefundBankAccount(rental.rentalPublicId, {
                AccountOwner: refundBankAccountOwner,
                Iban: refundIban,
                Bic: refundBic
            });
            setRefundBankAccountSubmitted(true);
            send("success", "RIB transmis.");
        } catch {
            send("warning", "Impossible d'enregistrer le RIB.");
        } finally {
            setLoadingRefundBankAccount(false);
        }
    };

    const renderMeetingDetails = () => {
        if (!hasDelivery) {
            return (
                <>
                    <h2>Lieu de rendez-vous</h2>
                    {needsAdvancePayment ? (
                        <>
                            <p>{rental.appointment_l2}</p>
                            <p className="rental-public-muted">L'adresse exacte sera communiquée une fois l'acompte versé.</p>
                        </>
                    ) : signatureBlocksContractAndAddress ? (
                        <>
                            <p>{rental.appointment_l2}</p>
                            <p className="rental-public-muted">L'adresse exacte sera communiquée après validation de la signature électronique.</p>
                        </>
                    ) : (
                        <>
                            <p>{rental.appointment_l1}</p>
                            <p>{rental.appointment_l2}</p>
                        </>
                    )}
                </>
            );
        }

        if (rental.delivery === "DeliveryWithPickup") {
            return (
                <>
                    <h2>Livraison et reprise</h2>
                    <p>Le matériel sera livré et récupéré à l'adresse convenue.</p>
                    {rental.deliveryAddress && <p>{rental.deliveryAddress}</p>}
                </>
            );
        }

        if (rental.delivery === "DeliveryWithPickupAndSetup") {
            return (
                <>
                    <h2>Livraison, installation et reprise</h2>
                    <p>Le matériel sera livré, mis en place et récupéré à l'adresse convenue.</p>
                    {rental.deliveryAddress && <p>{rental.deliveryAddress}</p>}
                </>
            );
        }

        if (rental.delivery === "DeliveryOnly") {
            return (
                <>
                    <h2>Livraison</h2>
                    <p>Le matériel sera livré à l'adresse convenue.</p>
                    {rental.deliveryAddress && <p>{rental.deliveryAddress}</p>}
                </>
            );
        }

        return (
            <>
                <h2>Récupération</h2>
                <p>Le matériel sera récupéré à l'adresse convenue.</p>
                {rental.deliveryAddress && <p>{rental.deliveryAddress}</p>}
            </>
        );
    };

    return (
        <>
            {( rental && rental.status !== 404) &&
                <div className="publicRental rental-public-page">
                    <section id="thumbnail" className="rental-public-hero">
                        <div className="rental-public-media">
                            {(!IsNullOrEmpty(rental.base64Picture)) ? (
                                <img className="rentalPicture" height="192" key={rental.rentalPublicId} alt={rental.name} src={rental.base64Picture || null} />
                            ) : (
                                <div className="no-picture no-picture-large"></div>
                            )}
                        </div>

                        <div className="rental-public-hero-content">
                            <p className="rental-public-eyebrow">Location à venir</p>
                            <h1>Bonjour {rental.clientFirstname}</h1>
                            <h2>{rental.name}</h2>
                            <div className="rental-public-dates">
                                <span>
                                    <i className="pi pi-calendar" aria-hidden="true"></i>
                                    <Moment locale="fr" calendar={calendarStrings}>
                                        {new Date(rental.startDate)}
                                    </Moment>
                                </span>
                                <span>
                                    <i className="pi pi-undo" aria-hidden="true"></i>
                                    Retour&nbsp;
                                    <Moment locale="fr" calendar={calendarStrings}>
                                        {new Date(rental.endDate)}
                                    </Moment>
                                </span>
                            </div>
                        </div>
                    </section>

                    <div id="mainContent" className="rental-public-content">
                        <div className="rental-public-grid">
                            <section className="rental-public-panel rental-public-panel-main">
                                {renderMeetingDetails()}
                                {(rental.servicePaymentFlow === "PlatformCodeAtPickup") && (
                                    <p className="rental-public-alert">Pensez à préparer le code {rental.serviceName} qui sera nécessaire lors du retrait.</p>
                                )}
                            </section>

                            {hasAction && (
                                <aside className="rental-public-panel rental-public-actions">
                                    <h2>À faire</h2>
                                    {showSignatureTodo && (
                                        <div className="rental-public-alert rental-public-signature-step">
                                            <p>En attente de signature électronique.</p>
                                        </div>
                                    )}
                                    {canPayAdvanceOnline && (
                                        <Button size="small" label={labelAdvanced} icon="pi pi-credit-card" loading={loadingAdvance} onClick={redirectToAdvancePayment} />
                                    )}
                                    {advancePaymentOnSiteRequired && (
                                        showAdvancePaymentBankTransferInstruction ? (
                                            <div className="rental-public-alert rental-public-bank-transfer">
                                                <p>Règlement de l'acompte par virement instantané.</p>
                                                <div className="rental-public-bank-field rental-public-bank-field--readonly">
                                                    <span>
                                                        <small>Montant</small>
                                                        <b>{bankTransferAmount}</b>
                                                    </span>
                                                </div>
                                                <div className="rental-public-bank-fields">
                                                    {bankTransferFields.map(renderCopyableBankTransferField)}
                                                </div>
                                            </div>
                                        ) : (
                                            <p>L'acompte sera réglé selon les modalités convenues avec le loueur.</p>
                                        )
                                    )}
                                    {showAdvancePaymentBankTransferReceived && (
                                        <p className="rental-public-paid"><i className="pi pi-check-circle" aria-hidden="true"></i> L'acompte par virement a bien été reçu.</p>
                                    )}
                                    {canDepositOnline && (
                                        <>
                                            <p>Une empreinte bancaire est demandée pour la caution. Le montant ne sera pas encaissé.</p>
                                            <Button size="small" label="Déposer la caution" icon="pi pi-shield" loading={loadingDeposit} onClick={redirectToDeposit} />
                                        </>
                                    )}
                                    {showCardDepositPending && (
                                        <p>Le dépôt de caution par carte bancaire sera disponible 24h avant le début de la location.</p>
                                    )}
                                    {showDepositBankTransferInstruction && (
                                        <div className="rental-public-alert rental-public-bank-transfer">
                                            <p>Caution par virement instantané.</p>
                                            <div className="rental-public-bank-field rental-public-bank-field--readonly">
                                                <span>
                                                    <small>Montant</small>
                                                    <b>{formatEuroAmount(rental.deposit / 100)}€</b>
                                                </span>
                                            </div>
                                            <div className="rental-public-bank-fields">
                                                {depositBankTransferFields.map(renderCopyableBankTransferField)}
                                            </div>
                                        </div>
                                    )}
                                    {hasBankTransferDeposit && rental.depositDone && (
                                        <p className="rental-public-paid"><i className="pi pi-check-circle" aria-hidden="true"></i> La caution par virement a bien été reçue.</p>
                                    )}
                                    {showRefundBankAccountForm && (
                                        <form className="rental-public-refund-form" onSubmit={saveRefundBankAccount}>
                                            <p>RIB pour le remboursement de la caution.</p>
                                            <span className="p-float-label">
                                                <InputText id="refundBankAccountOwner" value={refundBankAccountOwner} onChange={(event) => setRefundBankAccountOwner(event.target.value)} />
                                                <label htmlFor="refundBankAccountOwner">Titulaire du compte</label>
                                            </span>
                                            <span className="p-float-label">
                                                <InputText id="refundIban" value={refundIban} onChange={(event) => setRefundIban(event.target.value)} />
                                                <label htmlFor="refundIban">IBAN</label>
                                            </span>
                                            <span className="p-float-label">
                                                <InputText id="refundBic" value={refundBic} onChange={(event) => setRefundBic(event.target.value)} />
                                                <label htmlFor="refundBic">BIC</label>
                                            </span>
                                            <Button type="submit" size="small" label={refundBankAccountSubmitted ? "Mettre à jour le RIB" : "Transmettre mon RIB"} icon="pi pi-send" loading={loadingRefundBankAccount} />
                                            {refundBankAccountSubmitted && (
                                                <p className="rental-public-paid"><i className="pi pi-check-circle" aria-hidden="true"></i> RIB de remboursement transmis.</p>
                                            )}
                                        </form>
                                    )}
                                    {canPayOnline && (
                                        <>
                                            <p>Vous pouvez régler la location en ligne pour gagner du temps le jour du retrait.</p>
                                            <Button size="small" label="Régler ma location" icon="pi pi-credit-card" loading={loading} onClick={redirectToPayment} />
                                        </>
                                    )}
                                    {paymentOnSiteRequired && (
                                        <p>Le règlement de la location s'effectuera sur place.</p>
                                    )}
                                    {isPaid && (
                                        <p className="rental-public-paid"><i className="pi pi-check-circle" aria-hidden="true"></i> La location a été payée.</p>
                                    )}
                                </aside>
                            )}
                        </div>

                    {hasAssets && (
                        <section id="toolInfos" className="rental-public-panel rental-public-documents">
                            <h2>Documents et vidéos</h2>
                            <div className="rental-assets-links">
                                {assets.map((asset) => (
                                    <a
                                        className="rental-assets-link"
                                        href={`${materialUrlBase}/${asset.assetType}`}
                                        key={asset.id}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <i className={asset.assetType === 'video' ? 'pi pi-play-circle' : 'pi pi-file-pdf'} aria-hidden="true"></i>
                                        <span>{assetDisplayLabel(asset)}</span>
                                    </a>
                                ))}
                            </div>
                        </section>
                    )}

                    {(!hasAssets && rental.extraInformations && !hasDelivery) && (
                        <section id="toolInfos" className="rental-public-panel">
                            <h2>Informations utiles</h2>
                            <div>
                                {rental.extraInformations}
                            </div>
                        </section>
                    )}
                   
                    {canAccessContract ? (
                    <section className="rental-public-contract">
                        <div className="rental-public-section-heading">
                            <div>
                                <p className="rental-public-eyebrow">Contrat</p>
                                <h2>Votre contrat de location</h2>
                            </div>
                            <a className="rental-public-download" href={rental.pdf} target="_blank" rel="noopener noreferrer">
                                <i className="pi pi-external-link" aria-hidden="true"></i>
                                Ouvrir le PDF
                            </a>
                        </div>
                    <Accordion>
                        <AccordionTab header="Contrat" >
                            {isMobileView ? (
                                <div className="pdfMobileFallback">
                                    <p>
                                        Sur mobile, l'aperçu PDF intégré peut ne pas afficher toutes les pages.
                                    </p>
                                    <a
                                        className="p-button p-component"
                                        href={rental.pdf}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Ouvrir le contrat PDF
                                    </a>
                                </div>
                            ) : showContractPreview ? (
                                <div className="pdfViewer contract-preview-viewer">
                                    {loadingContractPreview && (
                                        <div className="contract-preview-loader" role="status" aria-live="polite">
                                            <i className="pi pi-spin pi-spinner" aria-hidden="true" />
                                            <span>Chargement de l'aperçu...</span>
                                        </div>
                                    )}
                                    <iframe
                                        className="pdfViewerFrame"
                                        src={rental.pdf}
                                        title="Contrat de location"
                                        loading="lazy"
                                        onLoad={() => setLoadingContractPreview(false)}
                                    >
                                        <p>
                                            Votre navigateur ne peut pas afficher le PDF.{" "}
                                            <a href={rental.pdf} target="_blank" rel="noopener noreferrer">
                                                Télécharger le contrat
                                            </a>
                                            .
                                        </p>
                                    </iframe>
                                </div>
                            ) : (
                                <Button
                                    size="small"
                                    label="Afficher l'aperçu"
                                    icon="pi pi-file-pdf"
                                    loading={loadingContractPreview}
                                    disabled={loadingContractPreview}
                                    onClick={() => {
                                        setLoadingContractPreview(true);
                                        setShowContractPreview(true);
                                    }}
                                />
                            )}
                        </AccordionTab>
                    </Accordion>
                    </section>
                    ) : null}

                </div>
                <div id="mainSubContent" >
                    <Outlet />
                </div>
                {(loadingSimilarTools || (similarTools && similarTools.items && similarTools.items.length > 0)) &&
                    <section className="rental-similar-section">
                        <div className="rental-similar-heading">
                            <div>
                                <p className="rental-public-eyebrow">Suggestions</p>
                                <h2>Dans la même catégorie</h2>
                            </div>
                            {(similarTools?.customToolsUrl) &&
                                <a href={"https://lokapp.fr/mesoutils/" + similarTools.customToolsUrl}>Voir tous les outils</a>
                            }
                        </div>
                        {loadingSimilarTools ? (
                            <div className="rental-similar-loading">
                                <ProgressSpinner style={{ width: "32px", height: "32px" }} strokeWidth="4" />
                                <span>Chargement des suggestions...</span>
                            </div>
                        ) : (
                            <div className="rental-similar-controls">
                                <Button
                                    aria-label="Outils precedents"
                                    className="rental-similar-nav rental-similar-nav-prev"
                                    disabled={!canSlideSimilar}
                                    icon="pi pi-chevron-left"
                                    onClick={() => moveSimilar(-1)}
                                    rounded
                                    severity="secondary"
                                    size="small"
                                />
                                <div className="card carousel rental-similar-carousel">
                                    <div
                                        className="rental-similar-track"
                                        style={{ '--similar-visible-count': visibleSimilarItems.length || 1 }}
                                    >
                                        {visibleSimilarItems.map((product) => (
                                            <div className="rental-similar-slide" key={product.publicId}>
                                                {productTemplate(product)}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <Button
                                    aria-label="Outils suivants"
                                    className="rental-similar-nav rental-similar-nav-next"
                                    disabled={!canSlideSimilar}
                                    icon="pi pi-chevron-right"
                                    onClick={() => moveSimilar(1)}
                                    rounded
                                    severity="secondary"
                                    size="small"
                                />
                            </div>
                        )}
                    </section>
                }
            </div>
            }
            {(rental.status === 404) &&
                <div>
                    <h1>Location terminée ou introuvable !</h1>
                </div>    
            }
            
        </>
        );
    
    
}
   
